module.exports = __webpack_public_path__ + "img/cannotvote.3419d871.png";